import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-end-icon-renderer",
  templateUrl: "./end-icon-renderer.component.html",
  host: { style: "display: block; height: 100%;" },
})
export class ChevronCellRenderer implements ICellRendererAngularComp {
  agInit(_params: ICellRendererParams): void {}
  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
